import React from "react";
import "./styles.guard.mobile.less";
import { useTranslation } from "react-i18next";
import { Card, GuardUi, Radio } from "./component-ui";
import { ColorSelect } from "../../components/ColorSelect";
import Tooltip from "rc-tooltip";

export const GuardMobile = ({ color, setColor, theme, setTheme }) => {
  const { t } = useTranslation();
  return (
    <div className="home-page-guard-mobile">
      <div className="home-page-guard-mobile-top">
        <div className="guard-top-title">
          {t("homePage.guard.guard-ui.title")}
        </div>
        <a className="guard-top-doc" href="https://docs.authing.cn/">
          <span>{t("homePage.guard.guard-ui.doc")}</span>
          <i className="icon authing-icon authing-arrow-right-s-line"></i>
        </a>
      </div>
      <div
        className="home-page-guard-mobile-inner"
        style={{ background: color }}
      >
        <GuardUi theme={theme} />
      </div>
      <Card>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 14,
            alignItems: "center",
          }}
        >
          <label style={{ cursor: "pointer" }}>
            <Radio checked label={t("homePage.guard.guard-ui.right.color")} />
          </label>
          <label style={{ cursor: "not-allowed" }}>
            <Tooltip
              placement="top"
              mouseLeaveDelay={0.001}
              trigger={["hover"]}
              overlay={t("homePage.guard.tooltip")}
              overlayInnerStyle={{
                background: "#272E3B",
                opacity: 1,
              }}
            >
              <div>
                <Radio label={t("homePage.guard.guard-ui.right.picture")} />
              </div>
            </Tooltip>
          </label>
        </div>
        <ColorSelect color={color} setColor={setColor} />
      </Card>
    </div>
  );
};
